<template>
<div class="rms-container">
	<div class="info">
		<div class="title">子公司数据汇总</div>
		<el-descriptions :title="item.companyName" :column="1" size="mini" border :labelStyle="{width: '130px'}" v-for="(item,index) in tableList" :key="index">
			<el-descriptions-item labelClassName="info-item" contentClassName="info-item" label="应收总额">{{ item.allDmbtrStr }}万元</el-descriptions-item>
			<el-descriptions-item labelClassName="info-item" contentClassName="info-item" label="逾期总额">{{ item.allM1M13Str }}万元</el-descriptions-item>
			<el-descriptions-item label="M4—M6总额">{{ item.allM4M6Str }}万元</el-descriptions-item>
			<el-descriptions-item label="M7—M9总额">{{ item.allM7M9Str }}万元</el-descriptions-item>
			<el-descriptions-item label="M10—M12总额">{{ item.allM10M12Str }}万元</el-descriptions-item>
			<el-descriptions-item label="M12+总额">{{ item.allM12UpStr }}万元</el-descriptions-item>
			<el-descriptions-item labelClassName="info-item" contentClassName="info-item" label="已发货未开票总额">{{ item.wkpDmbtrStr  }}万元</el-descriptions-item>
			<el-descriptions-item label="M4—M6总额">{{ item.allM4M6Str }}万元</el-descriptions-item>
			<el-descriptions-item label="当月计划开票金额">{{ item.predictVatAmountByCurrMonthStr }}万元</el-descriptions-item>
			<el-descriptions-item label="30天后逾期">{{ item.overDue30DaysAmountStr }}万元</el-descriptions-item>
			<el-descriptions-item label="">
				<template slot="label">
					大于月结<span class="red">60</span>天总额
				</template>
				{{ item.wkp60DmbtrStr }}万元
			</el-descriptions-item>
			<el-descriptions-item label="">
				<template slot="label">
					大于月结<span class="red">90</span>天总额
				</template>
				{{ item.wkp90DmbtrStr }}万元
			</el-descriptions-item>
			<el-descriptions-item labelClassName="info-item" contentClassName="info-item" label="已开票未回款总额">{{ item.whkDmbtrStr  }}万元</el-descriptions-item>
			<el-descriptions-item label="">
				<template slot="label">
					大于月结<span class="red">120</span>天总额
				</template>
				{{ item.whk120DmbtrStr }}万元
			</el-descriptions-item>
			<el-descriptions-item label="当月计划回款金额">{{ item.predictBackAmountByCurrMonthStr }}万元</el-descriptions-item>
			<el-descriptions-item label="M1+总额">{{ item.allM1UpStr }}万元</el-descriptions-item>
			<el-descriptions-item label="">
				<template slot="label">
					大于月结<span class="red">150</span>天总额
				</template>
				{{ item.whk150DmbtrStr }}万元
			</el-descriptions-item>
		</el-descriptions>
	</div>
</div>
</template>

<script>
export default {
name: "RMSSubsidiaryList",
data () {
	return {
		formInline:{
			workNumber: sessionStorage.getItem("WORKNUMBER"),
		},
		tableList: [],
	};
},
created() {
	if(!this.$route.query.workNumber && !this.formInline.workNumber){
		this.$router.replace({
			path: '/403',
		});
		return false;
	};
	
	if(this.$route.query.workNumber){
		sessionStorage.setItem("WORKNUMBER", this.$route.query.workNumber);
		this.formInline.workNumber = this.$route.query.workNumber;
		this.$router.replace({
			path: '/RMS/H5/subsidiaryList'
		});
	};
	
	this.init();
},
methods: {
	// 页初始化
	async init(){
		let res = await this.$api.receivableQyweixinDetail({ ...this.formInline });
		if(res.code===200){
			this.tableList = res.result;
		};
	},
}
};
</script>
<style lang="less" scoped>
.rms-container {
	height: 100%;
	overflow-y: auto;
}
.info {
	padding: 20px 15px;
	.title {
		line-height: 30px;
		font-size: 16px;
		text-align: center;
		font-weight: bold;
	}
	/deep/.el-descriptions {
		margin-top: 20px;
		.el-descriptions__header {
			margin-bottom: 5px;
		}
		.el-descriptions__title {
			font-size: 14px;
		}
		.el-descriptions__body {
			.el-descriptions-item__cell {
				color: #666;
			}
		}
		.info-item {
			font-weight: bold;
		}
		.red {
			color: red;
		}
	}
}
</style>
